import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=6e266b7f&scoped=true&"
var script = {}
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=6e266b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e266b7f",
  null
  
)

export default component.exports